export default {
  title: 'Manage Warehouse Authorization',
  subtitle:
    'The WMS account has been available, can be used by associated XED account.',
  linkedAuthorizedStores: 'Associated Authorized Stores',
  applyLog: 'Log Of Apply For Warehouse',
  warehouseNum: 'Warehouse No.',
  warehouseName: 'Warehouse Name',
  country: 'Region',
  city: 'City',
  state: 'Status',
  applyState: 'Application Status',
  auditedState: 'Audited State',
  applyTime: 'Application Time',
  authorizedTime: 'Authorized Time',
  applyRecord: 'Application Record',
  apply: 'Apply',
  log: 'Log',
  authorized: 'Authorized',
  unauthorized: 'Unauthorized',
  noApplyInProgress: 'No Applications In Progress',
  underReview: 'Under Review',
  platformName: 'Platform Name',
  storeName: 'Store Name',
  storeId: 'Store ID',
  logId: 'Log ID',
  storageLocationName: 'Storage Location Name',
  serialNumber: 'Serial Number',
  passed: 'Passed',
  rejected: 'Rejected'
}
